export default "__VITE_ASSET__BcY_inLw__"